export default __webpack_public_path__ + "static/media/you-lose-war-page.6c7f730c.png";